import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full h-screen overflow-auto bg-gray-lp-1000" }
const _hoisted_2 = { class: "bg-white rounded-xl m-4" }
const _hoisted_3 = { class: "p-4" }
const _hoisted_4 = { class: "py-2" }
const _hoisted_5 = { class: "py-2 font-semibold" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_7 = { class: "text-gray-lp-600 font-normal" }
const _hoisted_8 = {
  key: 1,
  class: "p-4"
}
const _hoisted_9 = { class: "flex flex-row justify-between items-baseline w-full gap-10" }
const _hoisted_10 = { class: "relative flex flex-col gap-2 w-1/2" }
const _hoisted_11 = { class: "flex items-center gap-x-4 py-2 justify-between" }
const _hoisted_12 = {
  for: "notes",
  class: "block text-sm font-medium text-gray-700"
}
const _hoisted_13 = { class: "w-1/2" }
const _hoisted_14 = { class: "flex justify-end pt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SummaryCollapsible = _resolveComponent("SummaryCollapsible")!
  const _component_CardDeposit = _resolveComponent("CardDeposit")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Notes = _resolveComponent("Notes")!
  const _component_SectionUploadPhotoCodReconcile = _resolveComponent("SectionUploadPhotoCodReconcile")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ImagePreviewReconcile = _resolveComponent("ImagePreviewReconcile")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_SummaryCollapsible, {
              data: _ctx.dataSummarySuccess,
              title: _ctx.$t('codReconcile.dailyDeposit.totalUangHarusDisetor'),
              totalString: _ctx.courierSummaryAmount
            }, null, 8, ["data", "title", "totalString"])
          ]),
          _createVNode("div", _hoisted_5, [
            (!_ctx.settlementListData.length)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode("p", null, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.setoranMasuk")) + " (" + _toDisplayString(_ctx.settlementListData.length) + ")", 1),
                  _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.belumAdaSetoran")), 1)
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode(_component_CardDeposit, {
                    deposits: _ctx.settlementListData,
                    onSeeDetail: _ctx.handleDetail
                  }, null, 8, ["deposits", "onSeeDetail"])
                ]))
          ]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('codReconcile.dailyDeposit.jumlahUangDisetor'),
            class: "w-full",
            "font-size": 14,
            asterisk: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.form.deposit,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.deposit = $event)),
                placeholder: _ctx.$t('codReconcile.dailyDeposit.placeholderInputAmount'),
                prefix: _ctx.prefixCurrency,
                format: _ctx.formatMoney,
                onChange: _cache[2] || (_cache[2] = (value) => _ctx.validationInput(value, 'deposit')),
                class: "py-3",
                error: _ctx.isErrorDeposit,
                errorCaption: _ctx.$t('codReconcile.dailyDeposit.errorAmount'),
                isErrorIconInput: false,
                "data-testid": "cod-deposit-input-amount"
              }, null, 8, ["modelValue", "placeholder", "prefix", "format", "error", "errorCaption"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_Notes, {
                notes: _ctx.courierNotes,
                "onUpdate:notes": _cache[4] || (_cache[4] = ($event: any) => (_ctx.courierNotes = $event)),
                loading: _ctx.courierNotesLoading
              }, {
                title: _withCtx(() => [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.catatan")), 1),
                    _createVNode("button", {
                      class: `text-sm ${_ctx.courierNotes ? 'text-red-lp-100' : 'text-gray-lp-600'} font-semibold`,
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSubmitCourierNotes && _ctx.onSubmitCourierNotes(...args))),
                      disabled: !_ctx.courierNotes
                    }, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.simpan")), 11, ["disabled"])
                  ])
                ]),
                _: 1
              }, 8, ["notes", "loading"])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode(_component_SectionUploadPhotoCodReconcile, {
                key: JSON.stringify(_ctx.courierNotePhotosUrl),
                modelValue: _ctx.courierNotePhotosUrl,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.courierNotePhotosUrl = $event)),
                "reconcile-for": "COD_AMOUNT",
                onOnSuccessUploadImage: _ctx.onSubmitCourierNotesPhoto,
                onOnSuccessDeleteImage: _ctx.onSubmitCourierNotesPhoto,
                onPreview: _cache[6] || (_cache[6] = 
                (index) => {
                  _ctx.previewCourierNotesPhoto = true;
                  _ctx.previewCourierNotesPhotoIndex = index;
                }
              ),
                iconTitle: false
              }, null, 8, ["modelValue", "onOnSuccessUploadImage", "onOnSuccessDeleteImage"])
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode(_component_LpButton, {
              title: _ctx.$t('codReconcile.dailyDeposit.setor'),
              textColor: "white",
              class: "mt-2 w-full",
              disabled: _ctx.isDisabled,
              onClick: _ctx.postCourierDailyDeposit
            }, null, 8, ["title", "disabled", "onClick"])
          ])
        ])
      ])
    ]),
    (_ctx.previewCourierNotesPhoto)
      ? (_openBlock(), _createBlock(_component_ImagePreviewReconcile, {
          key: 0,
          onClose: _cache[7] || (_cache[7] = () => (_ctx.previewCourierNotesPhoto = false)),
          data: _ctx.courierNotePhotosUrl.filter((url) => url),
          initialIndex: _ctx.previewCourierNotesPhotoIndex
        }, null, 8, ["data", "initialIndex"]))
      : _createCommentVNode("", true)
  ], 64))
}